import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import { FC, PropsWithChildren, useEffect, useMemo } from "react";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import growthBookConfig from "web/context/growthBookConfig";

const GrowthBookFF: FC<PropsWithChildren> = ({ children }) => {
  const gb = useMemo(() => {
    return new GrowthBook(growthBookConfig);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        await gb.init({ streaming: true });
      } catch (error) {
        newRelicErrorReport(
          error,
          "web-app/web/context/GrowthBookFF.tsx - gb.init"
        );
        console.error("Failed to initialize GrowthBook:", error);
      }
    })();
  }, []);

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
};

export default GrowthBookFF;
